import { render, staticRenderFns } from "./birdColorful.vue?vue&type=template&id=19857e82"
import script from "./birdColorful.vue?vue&type=script&lang=js"
export * from "./birdColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports